import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhatItIs() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-180">
      <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-10 lg:mb-12" data-id="element-181">
        What this is (and isn't)
      </h2>

      <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-182">
        <div className="space-y-6 lg:space-y-8" data-id="element-183">
          <h3 className="text-xl lg:text-2xl font-bold text-[#1B6B3A] border-b-2 border-[#1B6B3A] pb-2 inline-block" data-id="element-184">
            This is:
          </h3>
          <ul className="space-y-4 lg:space-y-5" data-id="element-185">
            {['A Practical Checklist System', 'A Calendar of Exactly What to Confirm and When', 'Scripts That Get Answers Fast'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-186">
                <Check className="w-5 h-5 lg:w-6 lg:h-6 text-[#1B6B3A] mt-1 flex-shrink-0" data-id="element-187" />
                <span className="text-lg lg:text-xl text-[#3D3D3D]" data-id="element-188">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="space-y-6 lg:space-y-8" data-id="element-189">
          <h3 className="text-xl lg:text-2xl font-bold text-[#6B6B6B] border-b-2 border-[#6B6B6B] pb-2 inline-block" data-id="element-190">
            This isn't:
          </h3>
          <ul className="space-y-4 lg:space-y-5" data-id="element-191">
            {['Legal Advice', 'Financial Advice', 'A Guarantee That Numbers Never Change'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-192">
                <X className="w-5 h-5 lg:w-6 lg:h-6 text-[#6B6B6B] mt-1 flex-shrink-0" data-id="element-193" />
                <span className="text-lg lg:text-xl text-[#6B6B6B]" data-id="element-194">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-12 lg:mt-16 text-center" data-id="element-195">
        <p className="text-xl lg:text-2xl font-serif italic text-[#1A1A1A]" data-id="element-196">
          It's a way to{' '}
          <span className="font-bold bg-[#F0F7F2] px-2 text-[#1B6B3A]" data-id="element-197">
            find changes early
          </span>{' '}
          and prevent last-minute chaos.
        </p>
      </div>
    </motion.section>;
}